export const SearchTypes = { // eslint-disable-line import/prefer-default-export
  NAME_EMAIL: {
    description: 'Search users and accounts that match',
    name: 'NAME_EMAIL',
    displayName: 'Name / Email',
  },
  ADVISOR_FIRM: {
    description: 'Search advisors by company name 1 or company name 2',
    name: 'ADVISOR_FIRM',
    displayName: 'Advisor firm',
  },
  ACCOUNT_NUMBER: {
    description: 'Search using the accountId property',
    name: 'ACCOUNT_NUMBER',
    displayName: 'Account number',
  },
  CUSIP: {
    description: 'Search using the cusip property',
    name: 'CUSIP',
    displayName: 'CUSIP',
  },
  NOTE_NUMBER: {
    description: 'Search using the noteId property',
    name: 'NOTE_NUMBER',
    displayName: 'Note number',
  },
};



// WEBPACK FOOTER //
// ./src/data/static/searchTypes.js